import { alkymetricsClient } from '../alkymetricsClient';

export const getWorkflows = async () => {
  const { data } = await alkymetricsClient.get('/workflows');
  return data;
};

export const getWorkflow = async (id) => {
  const { data } = await alkymetricsClient.get(`/workflows/${id}`);
  return data;
};

export const getWorkflowsByUser = async (userId) => {
  const { data } = await alkymetricsClient.get(`/workflows/user/${userId}`);
  return data;
};

export const createWorkflow = async (workflowData) => {
  const { data } = await alkymetricsClient.post('/workflows', workflowData);
  return data;
};

export const updateWorkflow = async (id, workflowData) => {
  const { data } = await alkymetricsClient.put(`/workflows/${id}`, workflowData);
  return data;
};

export const deleteWorkflow = async (id) => {
  const { data } = await alkymetricsClient.delete(`/workflows/${id}`);
  return data;
};

export const getWorkflowExecutions = async (workflowId) => {
  const { data } = await alkymetricsClient.get(`/workflows/${workflowId}/executions`);
  return data;
};

export const getExecutionById = async (executionId) => {
  const { data } = await alkymetricsClient.get(`/workflows/executions/${executionId}`);
  return data;
};

export const getWorkflowNodes = async () => {
  const { data } = await alkymetricsClient.get('/workFlowNodes');
  return data;
};

export const getWorkflowNodesByCategory = async (category) => {
  const { data } = await alkymetricsClient.get('/workFlowNodes', {
    params: { category },
  });
  return data;
};

export const getWorkflowTemplates = async () => {
  const { data } = await alkymetricsClient.get('/workflowTemplates');
  return data;
};
